<script setup>
import { STEP_CONTACT, STEP_KNOCK, STEP_MATERIAL, STEP_MODEL, STEP_SYSTEM, STEP_TYPE } from '../../constants/steps';
import { useConfiguratorStore } from '../../stores/configurator';
import ConfiguratorGroup from './ConfiguratorGroup.vue';
import GridOptions from './GridOptions.vue';
import SelectOptions from './SelectOptions.vue';
import ListOptions from './ListOptions.vue';
import DropdownOptions from './DropdownOptions.vue';
import ContactForm from './ContactForm.vue';
import { useUiStore } from '../../stores/ui.js';

const configurationStore = useConfiguratorStore();
const uiStore = useUiStore();

</script>

<template>
    <form class="ConfiguratorForm">
        <ConfiguratorGroup
            :title="$t('website.configurator.step.type')"
            :is-active="uiStore.currentStep === STEP_TYPE"
            is-first
        >
            <SelectOptions
                :options="configurationStore.options.type"
                v-model="configurationStore.configuration.type"
                name="type"
                @selected="uiStore.goToStep(STEP_SYSTEM);"
            />
        </ConfiguratorGroup>

        <ConfiguratorGroup
            :title="$t('website.configurator.step.system')"
            :is-active="uiStore.currentStep === STEP_SYSTEM"
        >
            <GridOptions
                :options="configurationStore.systemOptions"
                v-model="configurationStore.configuration.system"
                name="system"
                @set-details="uiStore.details = $emit"
            />
        </ConfiguratorGroup>

        <ConfiguratorGroup
            :title="$t('website.configurator.step.model')"
            :is-active="uiStore.currentStep === STEP_MODEL"
        >
            <GridOptions
                :options="configurationStore.modelOptions"
                v-model="configurationStore.configuration.model"
                name="model"
                @set-details="uiStore.details = $emit"
            />
        </ConfiguratorGroup>

        <ConfiguratorGroup
            :title="$t('website.configurator.step.material')"
            :is-active="uiStore.currentStep === STEP_MATERIAL"
        >
            <div class="ConfiguratorFilters tw-relative tw-mb-8 lg:tw-mb-12 tw-z-[100]">
                <DropdownOptions
                    :options="configurationStore.filterHolzArtOptions"
                    v-model="configurationStore.materialFilters.holzArt"
                    name="holzArt"
                />

                <DropdownOptions
                    :options="configurationStore.filterOberflachenBeschichtungOptions"
                    v-model="configurationStore.materialFilters.oberflaechenBeschichtung"
                    name="oberflaechenBeschichtung"
                />

                <DropdownOptions
                    :options="configurationStore.filterTuerModellOptions"
                    v-model="configurationStore.materialFilters.tuerModell"
                    name="tuerModell"
                />

                <span
                    v-if="configurationStore.materialFilters.holzArt || configurationStore.materialFilters.oberflaechenBeschichtung || configurationStore.materialFilters.tuerModell"
                    class="tw-text-brand-500 tw-text-sm tw-font-medium tw-mt-2 tw-cursor-pointer hover:tw-underline"
                    @click="configurationStore.materialFilters.holzArt = ''; configurationStore.materialFilters.oberflaechenBeschichtung = ''; configurationStore.materialFilters.tuerModell = ''"
                    v-t="`website.configurator.reset_filters`"
                >
                </span>
            </div>

            <ListOptions
                :options="configurationStore.materialOptions"
                v-model="configurationStore.configuration.material"
                name="material"
                @set-details="uiStore.details = $emit"
            />
        </ConfiguratorGroup>

        <ConfiguratorGroup
            :title="$t('website.configurator.step.knock')"
            :is-active="uiStore.currentStep === STEP_KNOCK"
        >
            <div class="ConfiguratorFilters tw-relative tw-mb-8 lg:tw-mb-12 tw-z-[100]">
                <DropdownOptions
                    :options="configurationStore.filterMaterialOptions"
                    v-model="configurationStore.knockFilters.material"
                    name="material"
                />

                <DropdownOptions
                    :options="configurationStore.filterRosettenArtOptions"
                    v-model="configurationStore.knockFilters.rosettenArt"
                    name="rosettenArt"
                />

                <span
                    v-if="configurationStore.knockFilters.material || configurationStore.knockFilters.rosettenArt"
                    class="tw-text-brand-500 tw-text-sm tw-font-medium tw-mt-2 tw-cursor-pointer hover:tw-underline"
                    @click="configurationStore.knockFilters.material = ''; configurationStore.knockFilters.rosettenArt = '';"
                    v-t="`website.configurator.reset_filters`"
                >
                </span>
            </div>

            <GridOptions
                :options="configurationStore.knockOptions"
                v-model="configurationStore.configuration.knock"
                name="knock"
                @set-details="uiStore.details = $emit"
            />
        </ConfiguratorGroup>

        <ContactForm v-if="uiStore.currentStep === STEP_CONTACT" />
    </form>
</template>